import { Component, OnInit, Input, Output, EventEmitter, DoCheck } from '@angular/core';
import {DjangoBaseUser, DjangoSessionAuthenticationService} from '../shared/authorization/custom';
import {Observable} from 'rxjs/Observable';
import {ProvincesService} from '../provinces/provinces.service';
import {StaticService} from './static.service';
import {FchartalgoService} from '../fchart/fchartalgo.service';
import {tap} from 'rxjs/operators';
import {GeneralMessages} from '../shared/services';

@Component({
  selector: 'app-consulta',
  templateUrl: './consulta.component.html',
  styleUrls: ['./consulta.component.scss']
})
export class ConsultaComponent implements OnInit, DoCheck {

  @Output()
      change: EventEmitter<Object> = new EventEmitter<Object>();

  provinces;
  cities = [];
  selectedcities = [];
  zoning = [];
  selectedzoning = [];
  project_type;
	project_unit;
  volumen_project_type;
  param;

  numero_vivendas = [2,2,0,0,0,0];

  user$: Observable<DjangoBaseUser>;

  offerloaded = null;
  adminview = false;
  alloffers = [];
  allusers = [];
  shown_users = [];
  active_filter = "todos";
  zone = null;
  acs_total = 0;
  contribution_manually_changed = false;


  constructor(private auth: DjangoSessionAuthenticationService, private staticS:StaticService,
                private provincesService:ProvincesService, private fchartalgo:FchartalgoService,
                private messaging: GeneralMessages) {
     this.user$ =  this.auth.getUserLogged$();
     window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  ngOnInit() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.setDefaultValues();
    this.getProvinces().subscribe();
  }

  ngDoCheck() {
      if (this.param.selected_normativa != this.staticS.getNormativa()){
        this.staticS.setNormativa(this.param.selected_normativa);
        this.ejecutarConsulta();
      }

      if (this.adminview != this.staticS.getAdminView()){
        this.adminview = this.staticS.getAdminView();
      }

      if (this.allusers != this.staticS.getAllUsers()){
        this.allusers = this.staticS.getAllUsers();
        this.filterUsers(this.active_filter);
      }


      if (this.alloffers != this.staticS.getAllOffers())
        this.alloffers = this.staticS.getAllOffers();

      if(!this.contribution_manually_changed && (this.zone != this.staticS.getZone() || this.acs_total != this.fchartalgo.get_acs_total() ) ){
          this.zone = this.staticS.getZone();
          this.acs_total = this.fchartalgo.get_acs_total();
          var demanda_acs = this.param.num_ocupantes * this.param.volumen;
          var contrib = 50;

          if(!this.param.selected_normativa) {
            if (this.zone == 'V' || this.zone == 'V '){
              if (demanda_acs <= 5000)  contrib = 60;
              else if (demanda_acs >= 5000 && demanda_acs <= 10000) contrib = 70;
              else if (demanda_acs > 10000) contrib = 70;
            }

            else if (this.zone == 'IV' || this.zone == 'IV '){
              if (demanda_acs <= 5000)  contrib = 50;
              else if (demanda_acs > 5000 && demanda_acs <= 10000) contrib = 60;
              else if (demanda_acs > 10000) contrib = 70;
            }

            else if (this.zone == 'III' || this.zone == 'III '){
              if (demanda_acs <= 5000)  contrib = 40;
              else if (demanda_acs > 5000 && demanda_acs <= 10000) contrib = 50;
              else if (demanda_acs >= 10000) contrib = 60;
            }

            else if (this.zone == 'II' || this.zone == 'II '){
              if (demanda_acs <= 5000)  contrib = 30;
              else if (demanda_acs > 5000 && demanda_acs <= 10000) contrib = 40;
              else if (demanda_acs > 10000) contrib = 50;
            }

            else if (this.zone == 'I' || this.zone == 'I '){
              if (demanda_acs <= 5000)  contrib = 30;
              else if (demanda_acs > 5000 && demanda_acs <= 10000) contrib = 30;
              else if (demanda_acs > 10000) contrib = 30;
            }
          }
          else { //Normativa 2019
            //si la demanda total es inferior a 5000 litros/día, la cobertura mínima a cumplir sea de 60 %.
            //Si la demanda es superior a esos 5000 litros/día, la cobertura mínima a cumplir es el 70 %.
            if (demanda_acs <= 5000)  contrib = 60;
            else  contrib = 70;
          }
          this.param.contribucion = contrib;
          if (contrib != this.param.contribucion_default){
            this.param.contribucion_default = contrib;
            this.ejecutarConsulta();
          }
      }

    if(this.offerloaded != this.staticS.getSelectedOffer()){
      this.offerloaded = this.staticS.getSelectedOffer();
      if (this.offerloaded){
        this.setParams();
        this.ejecutarConsulta();
      }
      else {
        this.param = this.staticS.getDefaultParam();
        this.param.selectedProvince = this.provinces[5];
        this.ejecutarConsulta();
      }
    }
  }

  setDefaultValues(){
    this.project_type = this.staticS.getDefaultProjectType();
    this.project_unit = this.staticS.getDefaultProjectUnit();
    this.param = this.staticS.getDefaultParam();
    this.param.tipovivienda = 2;
    this.param.selected_normativa = true;
    this.volumen_project_type = this.staticS.getDefaultVolumenType();
    this.contribution_manually_changed = false;
    this.numero_vivendas = [2,2,0,0,0,0];
    this.param.litros_dia = Math.round(0.01 * this.param.num_ocupantes * this.param.volumen * this.param.centralization);
  }


  calc_volume() {
    //this.param.num_unidades = 1;
    if (this.param.selectedProjectType == 'Viviendas'){

      if (this.param.num_unidades <=3)
        this.param.centralization = 100;
      else if (this.param.num_unidades >3 && this.param.num_unidades <=10)
        this.param.centralization = 95;
      else if (this.param.num_unidades >10 && this.param.num_unidades <=20)
        this.param.centralization = 90;
      else if (this.param.num_unidades >20 && this.param.num_unidades <=50)
        this.param.centralization = 85;
      else if (this.param.num_unidades >50 && this.param.num_unidades <=75)
        this.param.centralization = 80;
      else if (this.param.num_unidades >75 && this.param.num_unidades <=100)
        this.param.centralization = 75;
      else if (this.param.num_unidades >100)
        this.param.centralization = 70;


      if(this.param.tipovivienda == 1)
        this.param.num_ocupantes = 1.5;
      else if(this.param.tipovivienda == 2)
        this.param.num_ocupantes = 3;
      else if(this.param.tipovivienda == 3)
        this.param.num_ocupantes = 4;
      else if(this.param.tipovivienda == 4)
        this.param.num_ocupantes = 5;
      else if(this.param.tipovivienda == 5)
        this.param.num_ocupantes = 6;
      else if(this.param.tipovivienda == 6)
        this.param.num_ocupantes = 6;
      else if(this.param.tipovivienda == 7)
        this.param.num_ocupantes = 7;

      if(this.param.tipovivienda == 0){
        this.param.num_unidades = this.numero_vivendas[0] + this.numero_vivendas[1] + this.numero_vivendas[2]
                                  + this.numero_vivendas[3] + this.numero_vivendas[4] + this.numero_vivendas[5];
        this.param.num_ocupantes = Math.ceil(this.numero_vivendas[0]*1.5 + this.numero_vivendas[1]*3 + this.numero_vivendas[2]*4
                                  + this.numero_vivendas[3]*5 + this.numero_vivendas[4]*6 + this.numero_vivendas[5]*7);
      }
      else {
        this.param.centralization = 100;
        this.param.num_ocupantes = Math.ceil(this.param.num_ocupantes * this.param.num_unidades);
      }
    }
    this.param.units = this.project_unit[this.project_type.indexOf(this.param.selectedProjectType.toString())];
    this.param.volumen = this.volumen_project_type[this.project_type.indexOf(this.param.selectedProjectType.toString()) ];
    this.param.default_volumen = this.param.volumen;
    this.param.litros_dia = Math.round(0.01 * this.param.num_ocupantes * this.param.volumen * this.param.centralization);
  }

  selectProvince() {
    for(var i = 0; i < this.provinces.length; i++){
      if(this.provinces[i].id == this.param.selectedProvince.id){
        this.selectedcities = this.cities[i];
        this.selectedzoning = this.zoning[i];
      }
    }
    this.contribution_manually_changed = false;
    this.ejecutarConsulta();
  }

  selectCity() {
    for (var i = 0; i < this.selectedcities.length; i++){
      if(this.selectedcities[i] == this.param.city){
        this.staticS.setZone(this.selectedzoning[i]);
        this.param.zona = this.selectedzoning[i];
        break;
      }
    }
    this.contribution_manually_changed = false;
    this.ejecutarConsulta();
  }


  manualContribution(){
    this.contribution_manually_changed = true;
  }

  scrollAndEjecutar(){
    if (this.param.desviacion >= -45 && this.param.desviacion <= 45){
      window.scrollTo({ left: 0, top: 1110, behavior: 'smooth' });
      this.ejecutarConsulta();
    }
    else {
      this.messaging.warning('Verifica el Azimut', 'El ángulo de desviación respecto al sur debe ser\n ' +
                'entre -45 y 45 grados.');
    }
  }


  ejecutarConsulta() {
    this.fchartalgo.resetCaptador();
    this.fchartalgo.setConsulta(this.param);
  }

  unloadOffer() {
    this.param.tipovivienda = 2;
    this.staticS.unloadOffer();
    this.fchartalgo.setSelectedCaptador(this.fchartalgo.getCaptadores()[0], 150);
    this.offerloaded = null;
    this.param = this.staticS.getDefaultParam();
    this.param.selectedProvince = this.provinces[5];  //Default = Barcelona
    this.fchartalgo.setConsulta(this.param);
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  setParams(){
    for(var i = 0; i < this.provinces.length; i++)
      if(this.provinces[i].id == this.offerloaded.province){
        this.param.selectedProvince = this.provinces[i];
        this.selectedcities = this.cities[i];
        this.selectedzoning = this.zoning[i];
        break;
      }
    this.param.project = this.offerloaded.project;
    this.param.city = this.offerloaded.city;
    this.param.address = this.offerloaded.address;
    this.param.num_unidades = this.offerloaded.num_rooms;
    this.param.num_ocupantes = this.offerloaded.num_persons_room;
    this.param.volumen = this.offerloaded.unit_volume;
    this.param.selectedProjectType = this.offerloaded.project_type;
    this.param.interacumulador = this.offerloaded.interacumulador;
    this.param.desviacion = this.offerloaded.deviation;
    this.param.inclinacion = this.offerloaded.inclination;
    this.param.contribucion = this.offerloaded.contribution;
    this.param._default = this.offerloaded.contribution_default;
    this.param.zona = this.offerloaded.zona;
    this.param.temperatura_deseada = this.offerloaded.output_temp;
    this.param.tipovivienda = this.offerloaded.vivienda_type;
    this.param.litros_dia = Math.round(0.01 * this.param.num_ocupantes * this.param.volumen * this.param.centralization);
    if (this.offerloaded.normativa == "2016")
      this.param.selected_normativa  = false;
    else
      this.param.selected_normativa  = true;
  }

  getProvinces() {
    return this.provincesService.get().pipe(
      tap(data => {
        this.provinces = data;
        for (var i=0; i < this.provinces.length; i++){
          this.cities[i] = [];
          this.zoning[i] = [];
          var arr = this.provinces[i].cities.split(',');
          for (var j=0; j < arr.length; j++){
            var index = arr[j].length;
            if (arr[j].indexOf('0') > 0)
              index = arr[j].indexOf('0');
            if (arr[j].indexOf('1') > 0 && arr[j].indexOf('1') < index)
              index = arr[j].indexOf('1');
            if (arr[j].indexOf('2') > 0 && arr[j].indexOf('2') < index)
              index = arr[j].indexOf('2');
            if (arr[j].indexOf('3') > 0 && arr[j].indexOf('3') < index)
              index = arr[j].indexOf('3');
            if (arr[j].indexOf('4') > 0 && arr[j].indexOf('4') < index)
              index = arr[j].indexOf('4');
            if (arr[j].indexOf('5') > 0 && arr[j].indexOf('5') < index)
              index = arr[j].indexOf('5');
            this.cities[i][j] = arr[j].substring(0, index-1);
            this.zoning[i][j] = arr[j].substring(index+6, arr[j].length);
          }
        }
        this.param.selectedProvince = this.provinces[5];  //Default = Barcelona
        this.selectedcities = this.cities[5];
        this.selectedzoning = this.zoning[5];
        this.fchartalgo.setConsulta(this.param);
      })
    );
  }


  downloadOffer(id, type){
    var offer;
    for (var  i=0; i < this.alloffers.length; i++)
      if (this.alloffers[i].id == id){
        offer = this.alloffers[i];
        break;
      }
    if (offer){
      var href = offer.pdf;
      var filename = 'consulta.pdf';
      if (type == 'word'){
        href = offer.word;
        filename = 'consulta.docx';
      }
      var link;
      link = document.createElement('a');
      link.setAttribute('href', href);
      link.setAttribute('download', filename);
      link.setAttribute('target', '_blank');
      link.click();
    }
  }

  filterUsers(filter){
    this.active_filter = filter;
    if (this.active_filter == "todos")
      this.shown_users = this.allusers;
    else if (this.active_filter == "activos") {
      var filtered = [];
      for (var i=0; i < this.allusers.length; i++)
        if (this.allusers[i].is_active)
          filtered.push(this.allusers[i]);
      this.shown_users = filtered;
    }
    else if (this.active_filter == "inactivos") {
      var filtered = [];
      for (var i=0; i < this.allusers.length; i++)
        if (this.allusers[i].is_active  == false)
          filtered.push(this.allusers[i]);
      this.shown_users = filtered;
    }
  }

  downloadUserContacts(){
    let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "nombre,apellido,empresa,fecha-alta,correo" + "\r\n";
    for (var i=0; i < this.allusers.length; i++){
        var o = this.allusers[i];
        var row = o.first_name + "," + o.last_name + "," + o.company.replace(',', ' ') + "," + o.date_joined.substring(0,10) + "," + o.email;
        csvContent += row + "\r\n";
    }
    var encodedUri = encodeURI(csvContent);
    window.open(encodedUri);
  }

  downloadOffers(){
    let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "cliente,ciudad,fecha,proyecto,tipo" + "\r\n";
    for (var i=0; i < this.alloffers.length; i++){
        var o = this.alloffers[i];
        var row = o.client + "," + o.city + "," + o.created + "," + o.project + "," + o.project_type;
        csvContent += row + "\r\n";
    }
    var encodedUri = encodeURI(csvContent);
    window.open(encodedUri);
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/consulta.component.ts